<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 py-12 font-custom-light min-h-screen">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-black">

      <div class="container mx-auto px-4 max-w-7xl">

        <h3 class="text-3xl text-center font-bold">Inscripción invitado</h3>
        <br/>
        <h3 class="text-xl font-semibold text-center">Por favor completá el formulario en su totalidad</h3>

        <!-- Formulario -->     
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Apellido" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>          
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">         
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Empresa</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Empresa" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" readonly="true"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Cargo</label>
            <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Cargo" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="input-base" placeholder="Mail" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
        
        </div>  


        <div class="flex flex-wrap py-2 gap-3 justify-center">
          <button type="submit" class="mt-8 px-4 py-2 bg-transparent border border-black hover:bg-black text-black font-semibold hover:text-white rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>ENVIAR
          </button>
        </div>

        <!--
        <div class="text-lg  pt-6">&bull; Si ya estas acreditado y no te llego el correo podes descargar tu credencial con el DNI haciendo <a class="font-semibold" href="/nplay/credencial">click aquí</a></div>
        -->
      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import { useRoute } from 'vue-router'


import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import HeaderSection from '@/components/HeaderSection.vue'


import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, OrigenAcreditado} from 'qreventos-suite/services';
import { VERIFICADO, ORIGEN_ACREDITADO, SAVE, UPDATE } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';


export default defineComponent({
  components: {
    HeaderSection,
    InputText,
    Field, ErrorMessage, Form, BlockUI
  },
  data() {
    return {
      acreditado: undefined as unknown as Acreditado,
      isSubmitting: false,
      formData: {
        nombre: '',
        apellido: '',
        mail: '',
        cargo:'',
        empresa: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        nombre: yup.string().required('Ingresá tu nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingresá tu apellido').min(3, 'Al menos 3 letras'),
        empresa: yup.string().required('Ingresá el nombre de la empresa').min(3, 'Al menos 3 letras'),
        cargo: yup.string().required('Ingresá tu cargo').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingresá tu correo').email('Correo inválido'),
      });      
    }
  },
  methods: {
    cancelarAcreditacion() {
      this.$router.go(0);
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
        

        let acreditado: Acreditado = {} as Acreditado;
        acreditado.tipoAcreditado = { "id" : 2016 } as TipoAcreditado ;
        acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
        acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;
        acreditado.mail = this.formData.mail;
        acreditado.empresa = this.formData.empresa;
        acreditado.cargo = this.formData.cargo;
        acreditado.cantidad = 1;
        acreditado.notificar = true;
        acreditado.modificado = SAVE;      
        acreditado.dato15 = this.acreditado.codigoAcreditado + ' - ' + this.acreditado.nombre + ' ' + this.acreditado.apellido;

        this.acreditado.dato9 = "SI";
        this.acreditado.modificado = UPDATE;

        let acreditados: Acreditado[] = [];
        acreditados.push(this.acreditado);
        acreditados.push(acreditado);
        
        await suiteService.saveOrUpdateAll(suiteConfig.evento, acreditados);

        this.isSubmitting = false;
        Swal.fire({
          title: "¡Adicional cargado con éxito!",
          html: "En breve te enviaremos un mail con tu acreditación.<br/><br/>Revisá tu casilla de correo y spam.",
          icon: "success",
        }).then(() => {
          window.location.href = "https://www.nplay.convergencia.com";
        });
        

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
  },
  async mounted() {
    
    const route = useRoute();
    const hash = route.params.hash as string;

    this.acreditado = await suiteService.findAcreditadoByHash(suiteConfig.evento, hash);
    if(!this.acreditado) {
      Swal.fire({ title: "¡Atención!", html: "El acreditado no existe", icon: "error" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }

    if (this.acreditado.tipoAcreditado.id != 2016) {
      Swal.fire({ title: "¡Atención!", html: "Tipo de acreditado inválido", icon: "error" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }

    if (this.acreditado.estadoAcreditado.id == 1) {
      Swal.fire({ title: "¡Atención!", html: "El acreditado no abono entrada", icon: "error" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }

    if (this.acreditado.dato7 != "SI") {
      Swal.fire({ title: "¡Atención!", html: "No tiene promo 2x1", icon: "error" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }

    if (this.acreditado.dato9 == "SI") {
      Swal.fire({ title: "¡Atención!", html: "Usted ya registro su entrada adicional", icon: "error" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }

    this.formData.empresa = this.acreditado.empresa;

  }
});
</script>